import React from 'react';
import PropTypes from 'prop-types';
import {
  List, Link, ListItem, ListItemIcon, ListItemText, makeStyles, Tooltip, Collapse,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';

const useStyles = makeStyles((theme) => ({
  drawerListItemRoot: {
    '&.Mui-selected': {
      backgroundColor: 'rgba(0,0,0,0)',
    },
  },
  drawerListItemSelected: {
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    color: theme.palette.primary.main,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const D3DDrawerListCollapse = (props) => {
  const {
    path,
    Icon,
    labelId,
    routes,
    useTooltip,
    icons,
  } = props;
  const classes = useStyles();
  const location = useLocation();

  let initialOpen = false;
  routes.map((route) => {
    if (route.path === location.pathname) {
      initialOpen = true;
    }
    return null;
  });
  const [open, setOpen] = React.useState(initialOpen);

  const listItem = (
    <ListItem
      classes={{
        root: classes.drawerListItemRoot,
        selected: classes.drawerListItemSelected,
      }}
      selected={location.pathname === path || initialOpen}
      button
      onClick={() => setOpen(!open)}
    >
      <ListItemIcon><Icon /></ListItemIcon>
      <ListItemText primary={<FormattedMessage id={labelId} />} />
      {open ? <icons.ExpandLess /> : <icons.ExpandMore />}
    </ListItem>
  );

  return (
    <>
      {
        useTooltip ? (
          <Tooltip
            title={<FormattedMessage id={labelId} />}
            placement="right"
            arrow
          >
            {listItem}
          </Tooltip>
        ) : listItem
      }
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {
            routes.map((route) => (
              <Link
                key={`drawer-item-${path}-${route.path}`}
                href={route.path}
                color="inherit"
                underline="none"
              >
                <ListItem
                  button
                  className={classes.nested}
                  classes={{
                    root: classes.drawerListItemRoot,
                    selected: classes.drawerListItemSelected,
                  }}
                  selected={location.pathname === route.path}
                >
                  {
                    !route.Icon ? null : (
                      <ListItemIcon><route.Icon /></ListItemIcon>
                    )
                  }
                  <ListItemText primary={<FormattedMessage id={route.labelId} />} />
                </ListItem>
              </Link>
            ))
          }
        </List>
      </Collapse>
    </>
  );
};

D3DDrawerListCollapse.propTypes = {
  useTooltip: PropTypes.bool,
  icons: PropTypes.shape({
    ExpandMore: PropTypes.object.isRequired,
    ExpandLess: PropTypes.object.isRequired,
  }),
};

D3DDrawerListCollapse.defaultProps = {
  useTooltip: false,
  icons: seedDashboard3DrawersIcons,
};

export default D3DDrawerListCollapse;
